import { AutVrfAddActivateResponse } from 'scbk-shared-module/modules/Additional/types/api/autVrfAddActivate';
import { create } from 'zustand';

interface DeviceAuthState {
  step: number;
  setStep: (s: number) => void;
  macAddress: string;
  setMacAddress: (s: string) => void;
  maskMacAddress: string;
  setMaskMacAddress: (s: string) => void;
  deviceAlias: string;
  setDeviceAlias: (s: string) => void;
  allowOtherDeviceYn: string;
  setAllowOtherDeviceYn: (s: string) => void;
  authTelNo: string;
  setAuthTelNo: (s: string) => void;
  additionalInfo: AutVrfAddActivateResponse | null;
  setAdditionalInfo: (res: AutVrfAddActivateResponse) => void;
  clear: () => void;
}

export const useDeviceAuthStore = create<DeviceAuthState>((set) => ({
  step: 1,
  setStep: (s) => set({ step: s }),
  macAddress: '',
  setMacAddress: (s) => set({ macAddress: s }),
  maskMacAddress: '',
  setMaskMacAddress: (s) => set({ maskMacAddress: s }),
  deviceAlias: '',
  setDeviceAlias: (s) => set({ deviceAlias: s }),
  allowOtherDeviceYn: 'N',
  setAllowOtherDeviceYn: (s) => set({ allowOtherDeviceYn: s }),
  authTelNo: '',
  setAuthTelNo: (s) => set({ authTelNo: s }),
  additionalInfo: null,
  setAdditionalInfo: (res) =>
    set({
      additionalInfo: res,
    }),
  clear: () =>
    set({
      step: 1,
      macAddress: '',
      maskMacAddress: '',
      deviceAlias: '',
      allowOtherDeviceYn: 'N',
      authTelNo: '',
      additionalInfo: null,
    }),
}));
